module.exports = __webpack_public_path__ + "static/media/research.ba9a1de7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/research.svg
// module id = 2460
// module chunks = 0